export const productDetails = {
  boilerTreatment: {
    title: "Boiler Treatment Chemicals",
    image: "https://plus.unsplash.com/premium_photo-1682144426302-635f3bc67046?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    heroImage: "https://sms-environmental.co.uk/media/xs4datz1/industrial-boiler.png?mode=pad&width=2000",
    secondaryImage: "https://cdn.pixabay.com/photo/2016/04/25/13/52/bulgaria-1351947_1280.jpg",
    ctaImage: "https://media.istockphoto.com/id/1452166359/photo/a-female-engineer-works-in-a-chemical-plant-using-a-laptop-computer.jpg?s=2048x2048&w=is&k=20&c=IqyTSaWA6yW28etmlwrcqKMpe6BjfxULdp9ScRUuE68=",
    galleryImages: [
      "https://media.istockphoto.com/id/1452166359/photo/a-female-engineer-works-in-a-chemical-plant-using-a-laptop-computer.jpg?s=2048x2048&w=is&k=20&c=IqyTSaWA6yW28etmlwrcqKMpe6BjfxULdp9ScRUuE68=",
      "https://media.istockphoto.com/id/1452166359/photo/a-female-engineer-works-in-a-chemical-plant-using-a-laptop-computer.jpg?s=2048x2048&w=is&k=20&c=IqyTSaWA6yW28etmlwrcqKMpe6BjfxULdp9ScRUuE68=",
      "https://media.istockphoto.com/id/1452166359/photo/a-female-engineer-works-in-a-chemical-plant-using-a-laptop-computer.jpg?s=2048x2048&w=is&k=20&c=IqyTSaWA6yW28etmlwrcqKMpe6BjfxULdp9ScRUuE68=",
      "https://media.istockphoto.com/id/1452166359/photo/a-female-engineer-works-in-a-chemical-plant-using-a-laptop-computer.jpg?s=2048x2048&w=is&k=20&c=IqyTSaWA6yW28etmlwrcqKMpe6BjfxULdp9ScRUuE68=",
    ],
    processImages: {
      analysis: "https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?w=800",
      treatment: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800",
      monitoring: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800"
    },
    description: "At Amazetech Corporation, we provide a comprehensive range of boiler water treatment chemicals for low, medium, and high-pressure boilers, including power plant boilers. Our solutions are designed to optimize boiler performance, prevent corrosion, and enhance energy efficiency.",
    overview: [
      "Our boiler treatment chemicals are formulated using cutting-edge technology and premium quality raw materials to ensure optimal performance and reliability.",
      "We understand that each boiler system is unique, which is why we offer customized solutions tailored to your specific requirements and operating conditions.",
      "Our team of experts provides comprehensive support, from initial water analysis to ongoing monitoring and optimization of your boiler treatment program."
    ],
    keyFeatures: [
      {
        icon: "🔬",
        title: "Advanced Formulations",
        description: "State-of-the-art chemical formulations designed for maximum effectiveness and efficiency."
      },
      {
        icon: "🌡️",
        title: "Temperature Stable",
        description: "Products maintain their effectiveness across a wide range of operating temperatures."
      },
      {
        icon: "🔍",
        title: "Easy Monitoring",
        description: "Simple testing procedures for maintaining optimal chemical levels."
      },
      {
        icon: "♻️",
        title: "Environmentally Safe",
        description: "Eco-friendly formulations that meet or exceed environmental standards."
      }
    ],
    benefits: [
      {
        title: "Enhanced Efficiency",
        description: "Our chemicals ensure optimal boiler performance by preventing scale and corrosion, resulting in better heat transfer and reduced energy consumption."
      },
      {
        title: "Extended Equipment Life",
        description: "By protecting the internal and external surfaces of boilers, our products significantly extend equipment life, reducing downtime and maintenance costs."
      },
      {
        title: "Environmental Compliance",
        description: "Our solutions are formulated to be environmentally friendly, helping industries meet regulatory requirements while maintaining performance."
      },
      {
        title: "Customized Solutions",
        description: "We offer tailored formulations to suit the specific needs of different boiler pressure ranges and industry requirements."
      }
    ],
    productRange: [
      {
        name: "Antiscalants",
        icon: "🏭",
        description: "Prevent the formation of scale deposits in boilers, ensuring efficient heat transfer and prolonging the lifespan of boiler equipment."
      },
      {
        name: "Corrosion Inhibitors",
        icon: "🛡️",
        description: "Protect internal boiler surfaces from corrosion by forming a protective film, reducing maintenance costs and extending equipment life."
      },
      {
        name: "Oxygen Scavengers",
        icon: "⚗️",
        description: "Remove dissolved oxygen in feed water to prevent pitting and corrosion in boilers and pre-boiler systems."
      },
      {
        name: "pH Boosters",
        icon: "📊",
        description: "Regulate the pH level in the boiler water, preventing acidic or alkaline corrosion and enhancing the overall efficiency of the boiler system."
      },
      {
        name: "Descalants",
        icon: "🧪",
        description: "Effectively remove scale buildup from boiler surfaces, restoring optimal heat transfer and improving boiler efficiency."
      },
      {
        name: "Wet Lay-Up Chemicals",
        icon: "💧",
        description: "Designed for the protection of boilers during shutdown periods, these chemicals prevent corrosion and preserve the internal integrity of the system."
      }
    ],
    processes: [
      "Initial Water Analysis",
      "Chemical Treatment Selection",
      "Dosing System Setup",
      "Regular Monitoring",
      "Performance Optimization",
      "Preventive Maintenance"
    ],
    specifications: {
      "pH Range": "10.5 - 11.5",
      "Temperature Stability": "Up to 350°C",
      "Dosage Rate": "100-200 ppm",
      "Packaging": "25L, 50L, 200L drums",
      "Shelf Life": "2 years from date of manufacture",
      "Storage Temperature": "5°C - 40°C"
    },
    applications: [
      {
        icon: "🏭",
        title: "Power Plants",
        description: "Ideal for high-pressure boilers in power generation facilities."
      },
      {
        icon: "🏢",
        title: "Industrial Facilities",
        description: "Perfect for manufacturing plants and industrial processes."
      },
      {
        icon: "🏥",
        title: "Commercial Buildings",
        description: "Suitable for heating systems in commercial complexes."
      },
      {
        icon: "🏗️",
        title: "Construction",
        description: "Used in temporary boiler installations at construction sites."
      }
    ]
  },
  coolingTower: {
    title: "Cooling Tower Treatment Chemicals",
    image: "https://plus.unsplash.com/premium_photo-1661898205432-d648667b9c76?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    heroImage: "https://images.pexels.com/photos/459728/pexels-photo-459728.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    secondaryImage: "https://www.bvwater.co.uk/hubfs/corrosion_inhibitors.jpeg",
    ctaImage: "https://images.unsplash.com/photo-1623210828652-c4fa8b29d9a7?w=1470",
    galleryImages: [
      "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
      "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800"
    ],
    processImages: {
      waterTreatment: "https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?w=800",
      monitoring: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800",
      maintenance: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800"
    },
    description: "Our cooling tower treatment chemicals are specifically formulated to maintain optimal performance of cooling systems by preventing scale, controlling corrosion, and managing microbial growth. We provide comprehensive solutions for all types of cooling towers.",
    overview: [
      "Our cooling tower chemicals are designed to address multiple challenges simultaneously, providing complete system protection.",
      "We use advanced formulations that are environmentally friendly and comply with all regulatory requirements.",
      "Our solutions help maintain optimal heat transfer efficiency while protecting your equipment investment."
    ],
    keyFeatures: [
      {
        icon: "🦠",
        title: "Microbiological Control",
        description: "Advanced biocides to prevent algae, bacteria, and other microorganism growth."
      },
      {
        icon: "🛡️",
        title: "Corrosion Protection",
        description: "Multi-metal corrosion inhibitors for comprehensive system protection."
      },
      {
        icon: "💧",
        title: "Scale Prevention",
        description: "Effective scale inhibitors to maintain system efficiency."
      },
      {
        icon: "🔄",
        title: "Water Conservation",
        description: "Optimized cycles of concentration for water conservation."
      }
    ],
    benefits: [
      {
        title: "Improved System Efficiency",
        description: "Maintain optimal heat transfer efficiency by preventing scale formation and fouling."
      },
      {
        title: "Extended Equipment Life",
        description: "Protect system components from corrosion and scale damage, reducing maintenance costs."
      },
      {
        title: "Reduced Water Consumption",
        description: "Optimize cycles of concentration to minimize water usage and blowdown."
      },
      {
        title: "Regulatory Compliance",
        description: "Meet environmental regulations while maintaining system performance."
      }
    ],
    productRange: [
      {
        name: "Scale Inhibitors",
        icon: "🔄",
        description: "Prevent scale formation on heat exchange surfaces and system components."
      },
      {
        name: "Biocides",
        icon: "🦠",
        description: "Control microbiological growth to prevent system fouling and health risks."
      },
      {
        name: "Corrosion Inhibitors",
        icon: "🛡️",
        description: "Protect system metals from corrosion damage."
      },
      {
        name: "Dispersants",
        icon: "💫",
        description: "Keep suspended solids dispersed to prevent settling and fouling."
      },
      {
        name: "pH Controllers",
        icon: "⚖️",
        description: "Maintain optimal pH levels for system protection and efficiency."
      }
    ],
    processes: [
      "Initial System Assessment",
      "Water Analysis",
      "Treatment Program Design",
      "Chemical Addition",
      "Monitoring & Control",
      "Regular Maintenance"
    ],
    specifications: {
      "pH Control Range": "7.0 - 9.0",
      "Cycles of Concentration": "4-6 cycles",
      "Treatment Dosage": "50-200 ppm",
      "Monitoring Frequency": "Daily/Weekly",
      "Package Sizes": "20L, 200L drums",
      "Shelf Life": "1 year from manufacture"
    },
    applications: [
      {
        icon: "🏭",
        title: "Industrial Plants",
        description: "For process cooling and HVAC systems in industrial facilities."
      },
      {
        icon: "🏢",
        title: "Commercial Buildings",
        description: "For air conditioning and process cooling in commercial complexes."
      },
      {
        icon: "🏥",
        title: "Healthcare Facilities",
        description: "For specialized cooling needs in healthcare environments."
      },
      {
        icon: "🏗️",
        title: "Power Plants",
        description: "For large-scale cooling systems in power generation."
      }
    ]
  },
  chillerTreatment: {
    title: "Chiller Treatment Chemicals",
    image: "https://obliqueaqua.com/wp-content/uploads/2023/08/Chemical-treatment-for.jpg",
    heroImage: "https://www.socool.sg/wp-content/uploads/2024/06/Chilled-Water-Systems.jpg.webp",
    secondaryImage: "https://thumbs.dreamstime.com/b/water-cooling-tower-air-chiller-hvac-large-industrial-building-air-conditioner-water-cooling-tower-air-chiller-hvac-127724617.jpg",
    ctaImage: "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=1470",
    galleryImages: [
      "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
      "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800"
    ],
    processImages: {
      systemInspection: "https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?w=800",
      waterAnalysis: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800",
      treatmentSelection: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800",
      implementation: "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      monitoring: "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      maintenance: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800"
    },
    description: "Our chiller treatment chemicals are specially formulated to maintain peak efficiency in chiller systems while protecting against corrosion, scale, and biological growth. We ensure optimal heat transfer and system longevity.",
    overview: [
      "Our chiller treatment solutions are designed to maintain maximum efficiency while protecting your valuable equipment.",
      "We provide comprehensive treatment programs that address all aspects of chiller system maintenance.",
      "Our products are compatible with all major chiller manufacturers and types."
    ],
    keyFeatures: [
      {
        icon: "❄️",
        title: "Enhanced Cooling",
        description: "Maintain optimal heat transfer efficiency in your chiller system."
      },
      {
        icon: "🛡️",
        title: "System Protection",
        description: "Comprehensive protection against corrosion, scale, and biological growth."
      },
      {
        icon: "📊",
        title: "Performance Monitoring",
        description: "Easy-to-use testing and monitoring systems."
      },
      {
        icon: "💰",
        title: "Cost Effective",
        description: "Reduce energy consumption and maintenance costs."
      }
    ],
    benefits: [
      {
        title: "Energy Efficiency",
        description: "Maintain clean heat transfer surfaces for optimal energy efficiency."
      },
      {
        title: "Equipment Protection",
        description: "Prevent corrosion and scale damage to extend equipment life."
      },
      {
        title: "Reduced Maintenance",
        description: "Minimize system cleaning and maintenance requirements."
      },
      {
        title: "Performance Optimization",
        description: "Maintain peak system performance and reliability."
      }
    ],
    productRange: [
      {
        name: "Closed System Inhibitors",
        icon: "🔄",
        description: "Complete protection for closed chiller systems."
      },
      {
        name: "Scale Inhibitors",
        icon: "🛡️",
        description: "Prevent scale formation on heat transfer surfaces."
      },
      {
        name: "Corrosion Inhibitors",
        icon: "⚡",
        description: "Protect system metals from corrosion."
      },
      {
        name: "Glycol-Based Products",
        icon: "❄️",
        description: "Provide freeze protection and system protection."
      }
    ],
    processes: [
      "System Inspection",
      "Water Analysis",
      "Treatment Selection",
      "Implementation",
      "Monitoring",
      "Regular Maintenance"
    ],
    specifications: {
      "pH Range": "8.0 - 10.0",
      "Temperature Range": "-20°C to +95°C",
      "Inhibitor Levels": "1000-1500 ppm",
      "Conductivity": "<2000 µS/cm",
      "Package Sizes": "20L, 200L drums",
      "Testing Frequency": "Monthly"
    },
    applications: [
      {
        icon: "🏢",
        title: "Commercial HVAC",
        description: "For building comfort cooling systems."
      },
      {
        icon: "🏭",
        title: "Industrial Process",
        description: "For process cooling applications."
      },
      {
        icon: "🏥",
        title: "Healthcare",
        description: "For critical cooling in healthcare facilities."
      },
      {
        icon: "🏨",
        title: "Hospitality",
        description: "For hotel and resort cooling systems."
      }
    ]
  },
  roTreatment: {
    title: "Reverse Osmosis Treatment Chemicals",
    image: "https://plus.unsplash.com/premium_photo-1661899579134-0457cd1c4fb5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    heroImage: "https://www.rossari.com/wp-content/uploads/2020/01/RO-Chemical.jpeg",
    secondaryImage: "https://www.amezoltech.com/wp-content/uploads/2024/10/ro-image-new-1.jpg",
    ctaImage: "https://images.unsplash.com/photo-1519995451813-39e29e054914?w=1470",
    galleryImages: [
      "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
      "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800"
    ],
    processImages: {
      pretreatment: "https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?w=800",
      biologicalTreatment: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800",
      finalTreatment: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800"
    },
    description: "Our RO treatment chemicals are specifically designed to optimize reverse osmosis system performance, prevent membrane fouling, and extend membrane life. We provide comprehensive solutions for industrial and commercial RO systems.",
    overview: [
      "Our RO treatment solutions are formulated to address the unique challenges of membrane-based water treatment systems.",
      "We offer a complete range of pretreatment, maintenance, and cleaning chemicals to ensure optimal system performance.",
      "Our products are compatible with all major membrane manufacturers and help maintain system efficiency while reducing operational costs."
    ],
    keyFeatures: [
      {
        icon: "🔄",
        title: "Membrane Protection",
        description: "Advanced formulations to protect and extend membrane life."
      },
      {
        icon: "⚡",
        title: "Performance Enhancement",
        description: "Optimize system performance and water recovery rates."
      },
      {
        icon: "🧪",
        title: "Scale Prevention",
        description: "Effective scale inhibition for all water conditions."
      },
      {
        icon: "💧",
        title: "Quality Assurance",
        description: "Ensure consistent high-quality permeate water."
      }
    ],
    benefits: [
      {
        title: "Extended Membrane Life",
        description: "Protect and extend the life of expensive RO membranes through effective fouling prevention."
      },
      {
        title: "Reduced Operating Costs",
        description: "Optimize system performance to reduce energy consumption and maintenance requirements."
      },
      {
        title: "Improved Water Quality",
        description: "Maintain consistent high-quality permeate water production."
      },
      {
        title: "System Protection",
        description: "Comprehensive protection against scaling, fouling, and biological growth."
      }
    ],
    productRange: [
      {
        name: "Antiscalants",
        icon: "🛡️",
        description: "Prevent scale formation on membrane surfaces and system components."
      },
      {
        name: "Membrane Cleaners",
        icon: "🧼",
        description: "Specialized cleaners for organic and inorganic fouling removal."
      },
      {
        name: "Biocides",
        icon: "🦠",
        description: "Control biological growth in RO systems."
      },
      {
        name: "pH Adjusters",
        icon: "⚖️",
        description: "Maintain optimal pH for system performance."
      },
      {
        name: "Chlorine Removal",
        icon: "🔄",
        description: "Protect membranes from chlorine damage."
      }
    ],
    processes: [
      "Water Analysis",
      "Pretreatment Design",
      "Chemical Selection",
      "Dosing System Setup",
      "Performance Monitoring",
      "Membrane Cleaning"
    ],
    specifications: {
      "pH Range": "6.5 - 7.5",
      "Operating Temperature": "Up to 45°C",
      "Dosage Rates": "2-5 ppm",
      "Compatibility": "All membrane types",
      "Package Sizes": "20L, 200L drums",
      "Shelf Life": "2 years"
    },
    applications: [
      {
        icon: "🏭",
        title: "Industrial",
        description: "For process water and wastewater treatment."
      },
      {
        icon: "💧",
        title: "Desalination",
        description: "For seawater and brackish water treatment."
      },
      {
        icon: "🏢",
        title: "Commercial",
        description: "For building water treatment systems."
      },
      {
        icon: "🏥",
        title: "Healthcare",
        description: "For pharmaceutical and medical applications."
      }
    ]
  },
  defoamers: {
    title: "Defoamers",
    image: "https://images.unsplash.com/photo-1622322977885-8ee6d45ea016?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    heroImage: "https://images.unsplash.com/photo-1622322977879-af6982dcba00?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    secondaryImage: "https://www.amezoltech.com/wp-content/uploads/2024/09/upgrade.png",
    ctaImage: "https://images.unsplash.com/photo-1584017911766-d451b3d0e843?w=1470",
    galleryImages: [
      "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
      "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800"
    ],
    processImages: {
      processAnalysis: "https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?w=800",
      productSelection: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800",
      trialTesting: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800",
      implementation: "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      monitoring: "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      optimization: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800"
    },
    description: "Our industrial defoamers are specially formulated to control foam in various industrial processes, improving efficiency and product quality while reducing operational issues.",
    overview: [
      "Our defoamers are designed to provide rapid and long-lasting foam control in various industrial applications.",
      "We offer both oil-based and silicone-based formulations to suit different process requirements.",
      "Our products are carefully selected to ensure compatibility with your specific process conditions."
    ],
    keyFeatures: [
      {
        icon: "⚡",
        title: "Rapid Action",
        description: "Quick knockdown of existing foam."
      },
      {
        icon: "⏱️",
        title: "Long-Lasting",
        description: "Persistent foam control for extended periods."
      },
      {
        icon: "🌡️",
        title: "Temperature Stable",
        description: "Effective across wide temperature ranges."
      },
      {
        icon: "🔄",
        title: "Process Compatible",
        description: "No interference with downstream processes."
      }
    ],
    benefits: [
      {
        title: "Improved Process Efficiency",
        description: "Eliminate foam-related production slowdowns and improve process efficiency."
      },
      {
        title: "Quality Enhancement",
        description: "Prevent foam-related defects in final products."
      },
      {
        title: "Cost Reduction",
        description: "Reduce waste and improve production throughput."
      },
      {
        title: "Safety Improvement",
        description: "Prevent foam overflow and related safety hazards."
      }
    ],
    productRange: [
      {
        name: "Oil-Based Defoamers",
        icon: "🛢️",
        description: "Traditional defoamers for general industrial use."
      },
      {
        name: "Silicone Defoamers",
        icon: "💧",
        description: "High-performance defoamers for demanding applications."
      },
      {
        name: "Food-Grade Defoamers",
        icon: "🍽️",
        description: "Specially formulated for food processing applications."
      },
      {
        name: "Water-Based Defoamers",
        icon: "💧",
        description: "Environmentally friendly foam control solutions."
      }
    ],
    processes: [
      "Process Analysis",
      "Product Selection",
      "Trial Testing",
      "Implementation",
      "Monitoring",
      "Optimization"
    ],
    specifications: {
      "Active Content": "10-100%",
      "Viscosity Range": "100-5000 cPs",
      "Temperature Stability": "Up to 200°C",
      "pH Stability": "2-12",
      "Package Sizes": "25kg, 200kg drums",
      "Shelf Life": "1 year"
    },
    applications: [
      {
        icon: "🏭",
        title: "Wastewater Treatment",
        description: "Control foam in aeration basins and digesters."
      },
      {
        icon: "📜",
        title: "Pulp & Paper",
        description: "Prevent foam in paper manufacturing processes."
      },
      {
        icon: "🧪",
        title: "Chemical Processing",
        description: "Control foam in chemical reactions and processing."
      },
      {
        icon: "🍶",
        title: "Food Processing",
        description: "Manage foam in food and beverage production."
      }
    ]
  },
  paperAndSugar: {
    title: "Paper & Sugar Processing Chemicals",
    image: "https://plus.unsplash.com/premium_photo-1661920615655-cf7c362a5109?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    heroImage: "https://5.imimg.com/data5/SELLER/Default/2020/10/ZD/CL/II/39896959/paper-process-chemicals-500x500.jpg",
    secondaryImage: "https://media.istockphoto.com/id/1174905233/photo/reversing-falls-saint-john-new-brunswick-canada.jpg?s=612x612&w=0&k=20&c=Y_ayeXrxBOG0Jzv8ZxQkQUxn_hU8jQtQZSyenqegDCc=",
    ctaImage: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=1470",
    galleryImages: [
      "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
      "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800"
    ],
    processImages: {
      processAnalysis: "https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?w=800",
      chemicalSelection: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800",
      trialImplementation: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800",
      performanceMonitoring: "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      qualityControl: "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      processOptimization: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800"
    },
    description: "Our specialized chemicals for paper and sugar processing are designed to enhance production efficiency, improve product quality, and reduce operational costs in these demanding industries.",
    overview: [
      "We provide comprehensive chemical solutions for both paper manufacturing and sugar processing industries.",
      "Our products are formulated to address specific challenges in each industry while maintaining product quality.",
      "We focus on improving process efficiency while reducing environmental impact."
    ],
    keyFeatures: [
      {
        icon: "📈",
        title: "Efficiency Boost",
        description: "Improve production rates and reduce downtime."
      },
      {
        icon: "✨",
        title: "Quality Enhancement",
        description: "Ensure consistent high-quality output."
      },
      {
        icon: "♻️",
        title: "Eco-Friendly",
        description: "Environmentally responsible formulations."
      },
      {
        icon: "💰",
        title: "Cost Effective",
        description: "Optimize resource utilization and reduce waste."
      }
    ],
    benefits: [
      {
        title: "Enhanced Production",
        description: "Improve production efficiency and reduce processing time."
      },
      {
        title: "Quality Improvement",
        description: "Ensure consistent product quality and appearance."
      },
      {
        title: "Resource Optimization",
        description: "Reduce water and energy consumption in processing."
      },
      {
        title: "Waste Reduction",
        description: "Minimize waste and improve yield rates."
      }
    ],
    productRange: [
      {
        name: "Retention Aids",
        icon: "📎",
        description: "Improve fiber and filler retention in papermaking."
      },
      {
        name: "Clarification Aids",
        icon: "💧",
        description: "Enhance sugar juice clarification."
      },
      {
        name: "Defoamers",
        icon: "🔄",
        description: "Control foam in both paper and sugar processing."
      },
      {
        name: "Scale Inhibitors",
        icon: "🛡️",
        description: "Prevent scale formation in equipment."
      },
      {
        name: "Process Aids",
        icon: "⚡",
        description: "Improve overall process efficiency."
      }
    ],
    processes: [
      "Process Analysis",
      "Chemical Selection",
      "Trial Implementation",
      "Performance Monitoring",
      "Quality Control",
      "Process Optimization"
    ],
    specifications: {
      "pH Range": "4.0 - 10.0",
      "Temperature Stability": "Up to 120°C",
      "Dosage Rates": "0.5-5.0 kg/ton",
      "Shelf Life": "1 year",
      "Package Sizes": "25kg, 200kg drums",
      "Storage": "Cool, dry location"
    },
    applications: [
      {
        icon: "📜",
        title: "Paper Mills",
        description: "For all types of paper and board production."
      },
      {
        icon: "🍯",
        title: "Sugar Mills",
        description: "For sugar extraction and processing."
      },
      {
        icon: "📦",
        title: "Packaging",
        description: "For specialty paper and board manufacturing."
      },
      {
        icon: "🏭",
        title: "Industrial Processing",
        description: "For various industrial applications."
      }
    ]
  },
  miningConstruction: {
    title: "Mining & Construction Water Treatment",
    image: "https://images.unsplash.com/photo-1695169152266-d9ac86fab9c5?q=80&w=1856&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    heroImage: "https://www.veoliawatertech.com/sites/g/files/dvc3601/files/styles/default/public/image/2020/05/LAN_057_retouched-small.jpg?itok=c6pffiMf",
    secondaryImage: "https://chunkewatertreatment.com/wp-content/uploads/2024/07/water-treatment-for-mining-1024x585.png",
    ctaImage: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=1470",
    galleryImages: [
      "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
      "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800"
    ],
    processImages: {
      siteAssessment: "https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?w=800",
      waterAnalysis: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800",
      treatmentDesign: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800",
      systemImplementation: "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      performanceMonitoring: "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      environmentalCompliance: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800"
    },
    description: "Our specialized water treatment solutions for mining and construction industries are designed to handle the unique challenges of these sectors, ensuring environmental compliance while maximizing operational efficiency.",
    overview: [
      "We provide comprehensive water treatment solutions tailored to the specific needs of mining and construction operations.",
      "Our products are formulated to handle high suspended solids, heavy metals, and other challenging contaminants.",
      "We focus on water reuse and environmental protection while maintaining operational efficiency."
    ],
    keyFeatures: [
      {
        icon: "🌊",
        title: "Advanced Treatment",
        description: "State-of-the-art solutions for complex water treatment challenges."
      },
      {
        icon: "♻️",
        title: "Water Recovery",
        description: "Maximize water reuse and minimize environmental impact."
      },
      {
        icon: "🛡️",
        title: "Equipment Protection",
        description: "Protect valuable equipment from scale and corrosion."
      },
      {
        icon: "📊",
        title: "Process Optimization",
        description: "Improve operational efficiency and reduce costs."
      }
    ],
    benefits: [
      {
        title: "Environmental Compliance",
        description: "Meet or exceed environmental regulations for water discharge and reuse."
      },
      {
        title: "Cost Reduction",
        description: "Minimize water treatment costs through efficient processes and water recovery."
      },
      {
        title: "Operational Efficiency",
        description: "Maintain smooth operations with reliable water treatment solutions."
      },
      {
        title: "Resource Conservation",
        description: "Maximize water reuse and minimize environmental impact."
      }
    ],
    productRange: [
      {
        name: "Flocculants",
        icon: "💧",
        description: "Advanced polymers for efficient solid-liquid separation."
      },
      {
        name: "Coagulants",
        icon: "🔄",
        description: "Optimize particle aggregation and settling."
      },
      {
        name: "pH Adjusters",
        icon: "⚖️",
        description: "Maintain optimal pH for treatment processes."
      },
      {
        name: "Metal Precipitants",
        icon: "⚗️",
        description: "Remove heavy metals from process water."
      },
      {
        name: "Scale Inhibitors",
        icon: "🛡️",
        description: "Prevent scale formation in equipment and pipes."
      }
    ],
    processes: [
      "Site Assessment",
      "Water Analysis",
      "Treatment Design",
      "System Implementation",
      "Performance Monitoring",
      "Environmental Compliance"
    ],
    specifications: {
      "pH Range": "6.0 - 9.0",
      "TSS Removal": ">95%",
      "Metal Removal": ">99%",
      "Treatment Capacity": "10-1000 m³/hr",
      "Package Sizes": "25kg, 1000kg IBC",
      "Shelf Life": "1 year"
    },
    applications: [
      {
        icon: "⛏️",
        title: "Mining Operations",
        description: "For process water and mine drainage treatment."
      },
      {
        icon: "🏗️",
        title: "Construction Sites",
        description: "For dewatering and runoff treatment."
      },
      {
        icon: "🏢",
        title: "Tunneling Projects",
        description: "For groundwater and process water treatment."
      },
      {
        icon: "🌊",
        title: "Quarries",
        description: "For water management and environmental protection."
      }
    ]
  },
  etpTreatment: {
    title: "ETP Treatment Chemicals",
    image: "https://static.wixstatic.com/media/8380d5_3c0ba93de5ac457dbfea4dcf81cf31b0~mv2.jpg/v1/fill/w_1000,h_750,al_c,q_85,usm_0.66_1.00_0.01/8380d5_3c0ba93de5ac457dbfea4dcf81cf31b0~mv2.jpg",
    heroImage: "https://plus.unsplash.com/premium_photo-1682144326897-4a7149b991f5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    secondaryImage: "https://cdn.pixabay.com/photo/2017/10/07/16/27/treatment-plant-wastewater-2826990_960_720.jpg",
    ctaImage: "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=1470",
    galleryImages: [
      "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
      "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800"
    ],
    processImages: {
      pretreatment: "https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?w=800",
      biologicalTreatment: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800",
      finalTreatment: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800"
    },
    description: "Our Effluent Treatment Plant (ETP) chemicals are specifically formulated to handle industrial wastewater treatment challenges, ensuring environmental compliance and enabling water reuse opportunities.",
    overview: [
      "We provide comprehensive chemical solutions for all stages of effluent treatment.",
      "Our products are designed to handle diverse industrial wastewater streams effectively.",
      "We focus on achieving discharge compliance while maximizing water reuse potential."
    ],
    keyFeatures: [
      {
        icon: "🧪",
        title: "Complete Treatment",
        description: "Solutions for primary, secondary, and tertiary treatment."
      },
      {
        icon: "♻️",
        title: "Water Recovery",
        description: "Enable water reuse and reduce fresh water consumption."
      },
      {
        icon: "📊",
        title: "Process Control",
        description: "Maintain stable treatment performance."
      },
      {
        icon: "🌿",
        title: "Environmental Safety",
        description: "Eco-friendly formulations for sustainable treatment."
      }
    ],
    benefits: [
      {
        title: "Regulatory Compliance",
        description: "Meet all environmental discharge standards consistently."
      },
      {
        title: "Water Conservation",
        description: "Maximize water reuse potential and minimize fresh water intake."
      },
      {
        title: "Cost Optimization",
        description: "Reduce treatment costs through efficient processes."
      },
      {
        title: "Operational Reliability",
        description: "Ensure stable and reliable treatment performance."
      }
    ],
    productRange: [
      {
        name: "Coagulants",
        icon: "💧",
        description: "Optimize solid-liquid separation in primary treatment."
      },
      {
        name: "Flocculants",
        icon: "🔄",
        description: "Enhance floc formation and settling."
      },
      {
        name: "Biological Nutrients",
        icon: "🦠",
        description: "Support biological treatment processes."
      },
      {
        name: "Decolorants",
        icon: "🎨",
        description: "Remove color from industrial effluents."
      },
      {
        name: "Sludge Treatment",
        icon: "🔧",
        description: "Improve sludge dewatering and handling."
      }
    ],
    processes: [
      "Influent Analysis",
      "Treatment Program Design",
      "Chemical Dosing Setup",
      "Process Monitoring",
      "Performance Optimization",
      "Compliance Testing"
    ],
    specifications: {
      "pH Range": "6.5 - 8.5",
      "COD Reduction": ">90%",
      "BOD Reduction": ">95%",
      "TSS Removal": ">95%",
      "Package Sizes": "25kg, 200kg drums",
      "Shelf Life": "1 year"
    },
    applications: [
      {
        icon: "🏭",
        title: "Manufacturing",
        description: "For industrial process wastewater treatment."
      },
      {
        icon: "🧵",
        title: "Textiles",
        description: "For textile effluent treatment and color removal."
      },
      {
        icon: "🏢",
        title: "Commercial",
        description: "For commercial establishment wastewater treatment."
      },
      {
        icon: "🔧",
        title: "Automotive",
        description: "For automotive industry effluent treatment."
      }
    ]
  },
  stpTreatment: {
    title: "STP Treatment Chemicals",
    image: "https://www.hindustantimes.com/ht-img/img/2023/06/11/1600x900/DPCC-gathers-monthly-water-samples-from-both-the-i_1686508594502.jpg",
    heroImage: "https://journalsofindia.com/wp-content/uploads/2022/04/Okhla-Sewage-Treatment-Plant-1.jpg",
    secondaryImage: "https://www.biologicalwasteexpert.com/uploads/2/6/3/4/26349909/header_images/1729093124.jpg",
    ctaImage: "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=1470",
    galleryImages: [
      "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
      "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800"
    ],
    processImages: {
      preliminary: "https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?w=800",
      primaryTreatment: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800",
      secondaryTreatment: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800",
      tertiaryTreatment: "https://images.unsplash.com/photo-1581092160607-ee67df9c7ccb?w=800",
      disinfection: "https://images.unsplash.com/photo-1581092162384-8987c1d64926?w=800",
      sludgeManagement: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800"
    },
    description: "Our Sewage Treatment Plant (STP) chemicals are specifically formulated for efficient treatment of municipal and domestic wastewater, ensuring environmental compliance and enabling safe water reuse.",
    overview: [
      "We provide comprehensive chemical solutions for all stages of sewage treatment, from primary to tertiary treatment.",
      "Our products are designed to handle varying loads and compositions of municipal wastewater effectively.",
      "We focus on odor control, pathogen removal, and achieving consistent discharge quality."
    ],
    keyFeatures: [
      {
        icon: "🧪",
        title: "Complete Treatment",
        description: "Integrated solutions for all treatment stages."
      },
      {
        icon: "👃",
        title: "Odor Control",
        description: "Effective control of sewage-related odors."
      },
      {
        icon: "🦠",
        title: "Pathogen Removal",
        description: "Efficient elimination of harmful microorganisms."
      },
      {
        icon: "♻️",
        title: "Water Recovery",
        description: "Enable safe water reuse applications."
      }
    ],
    benefits: [
      {
        title: "Environmental Protection",
        description: "Ensure safe discharge of treated water to the environment."
      },
      {
        title: "Public Health Safety",
        description: "Remove pathogens and harmful contaminants from wastewater."
      },
      {
        title: "Resource Recovery",
        description: "Enable water reuse and biosolids recovery."
      },
      {
        title: "Community Wellbeing",
        description: "Minimize environmental impact and protect public health."
      }
    ],
    productRange: [
      {
        name: "Primary Treatment Aids",
        icon: "1️⃣",
        description: "Enhance primary settling and solid removal."
      },
      {
        name: "Biological Treatment Aids",
        icon: "🦠",
        description: "Support biological treatment processes."
      },
      {
        name: "Disinfection Chemicals",
        icon: "🧬",
        description: "Ensure pathogen removal and water safety."
      },
      {
        name: "Odor Control Products",
        icon: "💨",
        description: "Control and neutralize sewage odors."
      },
      {
        name: "Sludge Conditioners",
        icon: "🔄",
        description: "Improve sludge handling and dewatering."
      }
    ],
    processes: [
      "Preliminary Screening",
      "Primary Treatment",
      "Secondary Biological Treatment",
      "Tertiary Treatment",
      "Disinfection",
      "Sludge Management"
    ],
    specifications: {
      "pH Range": "6.5 - 8.5",
      "BOD Removal": ">95%",
      "COD Reduction": ">90%",
      "TSS Removal": ">95%",
      "Pathogen Removal": ">99.9%",
      "Package Sizes": "25kg, 200kg drums",
      "Shelf Life": "1 year",
      "Storage": "Cool, dry location"
    },
    applications: [
      {
        icon: "🏙️",
        title: "Municipal STPs",
        description: "For city-wide sewage treatment facilities."
      },
      {
        icon: "🏢",
        title: "Commercial Complexes",
        description: "For shopping malls and office buildings."
      },
      {
        icon: "🏘️",
        title: "Residential Communities",
        description: "For housing societies and townships."
      },
      {
        icon: "🏨",
        title: "Hospitality Sector",
        description: "For hotels and resorts."
      }
    ]
  }
}; 
